import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'mes-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styles: []
})
export class DateRangePickerComponent implements OnInit {
  @Input() fromDate: Date;
  @Input() toDate: Date;
  @Input() disabled: boolean = false;
  @Input() small: boolean = true;
  @Input() hasButton: boolean = true;
  @Input() format: 'short' | 'medium' | 'shortDate' | 'mediumDate' | 'dd.MM.yyyy' | 'dd.MM.yyyy HH:mm' | 'dd.MM.yyyy HH:mm:ss' = 'shortDate';
  @Input() showTime: boolean = false;
  @Input() showSeconds: boolean = false;
  @Input() initOpened = false;
  @Input() class: string;
  @Input() autoClose: boolean | 'inside' | 'outside' = 'outside';

  @Output() dateSelect = new EventEmitter<{ From: Date, To: Date }>();
  width: string;

  constructor() {
  }

  ngOnInit(): void {
    this.width = this.getMinWidth();
  }

  getMinWidth() {
    const factor = this.small ? 1 : 1.12;
    switch (this.format) {
      case 'short': return 184 * factor + 'px';
      case 'medium': return 284 * factor + 'px';
      case 'shortDate': return 122 * factor + 'px';
      case 'mediumDate': return 186 * factor + 'px';
      case 'dd.MM.yyyy': return 145 * factor + 'px';
      case 'dd.MM.yyyy HH:mm': return 210 * factor + 'px';
      case 'dd.MM.yyyy HH:mm:ss': return 242 * factor + 'px';
      default: return 150 * factor + 'px';
    }
  }
}
